import { Controller } from "@hotwired/stimulus"

// MS54 #3040 — "advanced-search-toggle" Stimulus controller.
//
// CSP-safe replacement for the nonce-less inline <script> that toggled the
// "Advanced Options" reveal on /search (app/views/search/index.html.erb). The
// enforcing nonce CSP (script-src :self + nonce, no unsafe_inline — #1222)
// silently blocks nonce-less inline scripts, so the advanced-search form
// (#advancedSearch, rendered display:none by _advanced_form.html.erb) was
// permanently unreachable. The toggle control fires `toggle`, which flips the
// form target between shown and hidden — mirroring resume_reveal / history_back.
export default class extends Controller {
  static targets = ["form"]

  toggle(event) {
    event.preventDefault()
    if (!this.hasFormTarget) return

    // #advancedSearch renders with .d-none; flip it to show/hide the form.
    this.formTarget.classList.toggle("d-none")
  }
}
